export function getDisplayClaimNumber(claimNumber, lineOfBusiness, isTPA, status) {
    const workersComp = ['WC7WorkersComp', "Workers' Compensation"]

    // status only provided in CE
    if (workersComp.includes(lineOfBusiness) && isTPA && (status == null || status.toUpperCase() !== 'DRAFT')) return "TBD";
    return claimNumber;
}


this?.props?.history?.location?.state?.lobName === "WC7WorkersComp"
